const platforms = {
    "wn": 'News',
    "wf": 'Forums',
    "wb": 'Blogs',
    "fb": 'Facebook',
    "fbgr": 'Facebook Group',
    "fbcom": 'Facebook Comment',
    "fbp": 'Facebook Profile',
    "ig": 'Instagram',
    "tw": 'X',
    "in": 'Linkedin',
    "rd": 'Reddit',
    "yt": 'Youtube',
    "tt": 'TikTok',
    "tg": 'Telegram',
    "bsky": 'Bluesky',
    
};

const getPlatformLabel = (id) => {
    const label = platforms[id];
    return label ? label.replace("--","").trim() : ""
}

export default platforms;
export {getPlatformLabel};